import React from 'react'
import { createRegisterableComponent } from '@news-mono/web-common'
import { TopicList } from './TopicList'
import { TopicV4DTO } from '@west-australian-newspapers/publication-types'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface TopicListRouteProps {
    topics: { primary: TopicV4DTO; secondary: TopicV4DTO[] }
    verticalSpacing?: keyof ThemeMargins
}

export const TopicListRegistration = createRegisterableComponent(
    'topic-list',
    (props: TopicListRouteProps) => {
        const { topics, verticalSpacing } = props
        return (
            <TopicList
                primaryTopic={topics.primary}
                secondaryTopics={topics.secondary}
                verticalSpacing={verticalSpacing}
            />
        )
    },
)
